/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs */

const en_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titles, bullets and backend terms tuned per marketplace, refreshed on schedule.`)
};

const ar_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عناوين ونقاط ومصطلحات الباك إند مضبوطة لكل سوق، تحدث بجدول.`)
};

const bn_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শিরোনাম, বুলেট আর ব্যাকএন্ড পদ প্রতি মার্কেটপ্লেসে টিউন করা, সময়সূচিতে তাজা।`)
};

const de_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel, Aufzählungspunkte und Backend-Begriffe pro Marktplatz abgestimmt, planmäßig aktualisiert.`)
};

const es_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos, viñetas y términos internos ajustados por marketplace, actualizados según calendario.`)
};

const fr_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titres, puces et termes internes réglés par marketplace, actualisés selon calendrier.`)
};

const pt_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos, pontos e termos internos ajustados por marketplace, atualizados com calendário.`)
};

const zh_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按平台调优标题、五点和后台关键词，定时刷新。`)
};

const tr_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlıklar, maddeler ve arka plan terimleri pazar yeri başına ayarlı, zamanlı tazelenir.`)
};

const ru_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовки, буллеты и скрытые термины настроены под маркетплейс, обновляются по расписанию.`)
};

const pl_svc_ecommerce_amazon_tools_listings_desc8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuły, bullety i terminy backendowe dostrojone pod marketplace, odświeżane według planu.`)
};

/**
* | output |
* | --- |
* | "Titles, bullets and backend terms tuned per marketplace, refreshed on schedule." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_listings_desc8 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Listings_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_listings_desc8(inputs)
	return en_svc_ecommerce_amazon_tools_listings_desc8(inputs)
});
export { svc_ecommerce_amazon_tools_listings_desc8 as "svc_ecommerce-amazon-tools_LISTINGS_desc" }